import { render, staticRenderFns } from "./administrationBdm.vue?vue&type=template&id=8fb5cd7a&scoped=true&"
import script from "./administrationBdm.vue?vue&type=script&lang=js&"
export * from "./administrationBdm.vue?vue&type=script&lang=js&"
import style0 from "./administrationBdm.vue?vue&type=style&index=0&id=8fb5cd7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb5cd7a",
  null
  
)

export default component.exports